import React, { Children, useState } from 'react';
import Pagination from '@mui/material/Pagination';

// import JS files
// import { useUserData } from "../../context/UserDataContext";
import MuiTheme from './MuiTheme';

// import Others files

const MuiPagination = ({ count, onChange }) => {
  return (
    <>
      <div className="pagination">
        <MuiTheme>
          <Pagination
            onChange={onChange}
            count={count}
            color="primary"
            sx={{
              '& .Mui-selected': {
                ':hover': {
                  backgroundColor: '#c6c6c6',
                  borderRadius: '1px',
                  color: '#f5f5f5',
                },
                backgroundColor: 'transparent',
                color: 'rgb(33, 158, 183)',
                // fontWeight: "bold",
              },
            }}
          />
        </MuiTheme>
      </div>
    </>
  );
};

export default MuiPagination;
